<template>
    <el-dialog title="修改角色" width="70%" :append-to-body="true" :visible.sync="changeRoleVisible" center v-loading="changeRoleLoading" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"	
    element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-form ref="RoleForm" :rules="changeRoleRules" :model="RoleForm" label-width="180px" size="mini" >
            <el-form-item label="角色名称：" prop="role.roleName" >
                <el-input v-model="RoleForm.role.roleName" placeholder="角色名称"  clearable :maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="角色描述：" prop="role.description">
                <el-input v-model="RoleForm.role.description" placeholder="角色描述" clearable type="textarea" :maxlength="150" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="角色状态：" prop="role.status">
                <el-radio-group size="mini" v-model="RoleForm.role.status">
                    <el-radio-button :label="0">正常</el-radio-button>
                    <el-radio-button :label="1">禁用</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="角色权限：" prop="rightList">
                <div class="rightDiv">
                    <el-transfer v-model="RoleForm.rightList" :data="rightList" :props="{key: 'rightId',label: 'rightName'}"
                    :titles="['未含权限', '已含权限']"  :format="{noChecked: '${total}',hasChecked: '${checked}/${total}' }"
                    >
                        <span slot-scope="{ option }">
                        <el-tooltip :content="option.rightName+':('+option.notes+')'" placement="right" effect="light">
                            <span>{{ option.rightName }}</span> 
                        </el-tooltip>
                        </span>
                    </el-transfer>
                </div>
            </el-form-item>
            <el-form-item label="创建时间：">
                <el-tag type="info" size="mini">{{RoleForm.role.createTime|dateformatAll('YYYY-MM-DD HH:mm:ss')}}</el-tag>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="changeRole">提交</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name:'ChangeRole',
    props:{
        changeRoleVisible:Boolean,
        RoleFormCp:Object,
        rightList:Array,
        flushRoleList:Function,
    },
    data(){
        return {
            changeRoleLoading:false,
            changeRoleRules:{
                'role.roleName':[{required:true,message:"角色名称必填",trigger:'blur'}],
                'role.description':[{required:true,message:"角色描述必填",trigger:'blur'}],
                rightList:[{ type: 'array', required: true, message: '至少需要1个角色权限', trigger: 'change' }]
            },
            RoleForm:{
                role:{},
                rightList:[],
            }
        }
    },
    mounted(){},
    methods:{
        close(){
            this.$emit('changeVisible',false)
        },
        changeRole(){
            this.$refs.RoleForm.validate(async valid=>{
                if(valid){
                    const confirmresult=await this.$confirm('将要更新角色信息，请确定是否继续？','提示',{
                        confirmButtonText:'确定',cancelButtonText:'取消',type:'warning'
                    }).catch(err=>err)
                    if(confirmresult!=='confirm'){
                        return this.$message.info('已取消操作')
                    }else{
                        this.changeRoleLoading=true
                        const{data:res}=await this.$http.post('role/change',this.RoleForm).catch(err => err)
                        if(res){
                            this.$message.success('操作成功')
                            this.close()
                            this.flushRoleList()
                        }
                        this.changeRoleLoading=false
                    }
                }else{
                    return false
                }
            })
        },
    },
    watch:{
        RoleFormCp(n){
            this.RoleForm=n
        }
    }
}
</script>
<style scope>
.el-transfer-panel{
width: 280px;
}
.el-transfer-panel__list.is-filterable{
height: 280px;
}
</style>